<template>
  <div class="optionSelets">
    <div class="title-limit">
      <span class="title">
        {{ title }}
      </span>
      <span
        v-if="!isSingle && limit"
        class="limit"
      >
        {{ checked.length }} / {{ limit }}
      </span>
    </div>
    <div class="options">
      <div
        v-for="(item, i) in opts"
        :key="i"
        class="item"
        :class="{ checked: checked.includes(item) }"
        @click="chooseOpt(item)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  props: {
    isSingle: {
      type: Boolean,
      required: false
    },
    title: {
      type: String
    },
    opts: {
      type: Array, // as () => Array<string>,
      default () {
        return []
      }
    },
    checked: {
      type: Array, // as () => Array<string>,
      default () {
        return []
      }
    },
    limit: {
      type: Number,
      default: 0
    }
  },
  methods: {
    chooseOpt (item) {
      if (this.isSingle) {
        this.chooseOpt_single(item)
      } else {
        this.chooseOpt_multiple(item)
      }
    },
    chooseOpt_single (item) {
      this.$emit('update:checked', [item])
    },
    chooseOpt_multiple (item) {
      const index = this.checked.indexOf(item)
      const newArr = [...this.checked]
      if (index !== -1) {
        // 存在，则删除
        newArr.splice(index, 1)
        this.$emit('update:checked', newArr)
      } else {
        if (this.limit && this.checked.length === this.limit) {
          // 超出限制，则提示
          return
        }
        // 不存在，则添加
        newArr.push(item)
        this.$emit('update:checked', newArr)
      }
    }
  }
})
</script>

<style scoped lang="scss">
.optionSelets {
  .title-limit {
    margin-bottom: 22px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .title {
      font-size: 17px;
      color: #353535;
      font-weight: bold;
    }

    .limit {
      font-size: 14px;
      color: #025fea;
    }
  }

  .options {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;

    .item {
      // width: 95px;
      // width: 30%;
      padding: 0 20px;
      margin-right: 3.3%;
      margin-bottom: 15px;
      height: 35px;
      line-height: 35px;
      background-color: #f6f6f6;
      border-radius: 4px;
      color: #666666;
      font-size: 13px;
      cursor: pointer;
      &.checked {
        background-image: linear-gradient(90deg, #68a4ff 0%, #3484fc 100%);
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/ChooseIndustryAndRiskDialog/optionSelets.vue